<template>
  <div >
    <div class="design_box_out">
      <!--<div class="tool_company">-->
      <div class="company-desc design_box">
        <div>
          <img :src="property.pic?property.pic:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'" alt="">
        </div>
        {{property.body}}
      </div>
      <!--</div>-->
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>


